import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../config/date_format';
import {FuseConfig} from '../../@fuse/types';
import {fuseConfig_default} from '../fuse-config';
import {fuseConfig_enegrypac_theme} from '../fuse-config/energypac-theme';
import {fuseConfig_pac_theme} from '../fuse-config/pac-theme';
import { fuseConfig_energypac_airflow_theme} from '../fuse-config/energypac-air-flow';
import {Customer} from '../models/customer';
import {CustomerRef} from '../models/customer-ref';
import {Distributor} from '../models/distributor';
import {DistributorRef} from '../models/distributor-ref';
import {Market} from '../models/market';
import {MarketRef} from '../models/market-ref';
import {MarketLevel} from '../models/market-level';
import {MarketLevelRef} from '../models/market-level-ref';
import {Product} from '../models/product';
import {ProductRef} from '../models/product-ref';
import {UserRoleRef} from '../models/user-role-ref';
import {UserRole} from '../models/user-role';

export function getEnumSelector(pTargetEnum: any): { title: string; value: any }[] {
    return Object.keys(pTargetEnum).map(pKey => ({value: pKey, title: pTargetEnum[pKey]}));
}

export function findEnum(pTargetEnum: any, pTargetKey: string): string {
    return Object.keys(pTargetEnum).filter(pKey => pTargetEnum[pKey] === pTargetKey)[0];
}

export function padString(pInputString: string, pPadString: string, pLength: number, pLeft = true): string {
    return pLeft ? pInputString.padStart(pLength, pPadString) : pInputString.padEnd(pLength, pPadString);
}

export function arrayRemove(pArray: any[], pItem: any): any[] {
    const index = pArray.indexOf(pItem);
    if (index > -1) {
        pArray.splice(index, 1);
    }
    return pArray;
}

export function getDaysInMonth(month, year): number {
    return new Date(year, month, 0).getDate();
}

export function getDayDifference(fromDate, toDate): number {
    const startDate = new Date(fromDate);
    const endDate = new Date(toDate);

    const dateDifference = endDate.getTime() - startDate.getTime();
    return Math.floor(dateDifference / (1000 * 60 * 60 * 24)) + 1;
}

export function prepareObject(pObject: Object): Object {
    const newObject = {...pObject};
    Object.keys(newObject).forEach(pKey => {
        if (newObject[pKey] == null || newObject[pKey] == 'null' || newObject[pKey] == undefined) {
            delete newObject[pKey];
        }
    });
    return newObject;
}

export function getOrganizationLogoName(pOrgCode: string): string {
    let imagePath = 'biz_motion.png';

    const siteLink = window.location.href;
    if (siteLink.includes('robisfa1.robimotion.com') || siteLink.includes('web.axentec.robisfa.com')) {
        return 'robi.png';
    }

    if (pOrgCode == null) {
        return imagePath;
    } else if (pOrgCode === 'wltn') {
        imagePath = 'walton.png';
    } else if (pOrgCode === 'strline') {
        imagePath = 'starline.png';
    } else if (pOrgCode === 'edrc') {
        imagePath = 'edruc.png';
    } else if (pOrgCode === 'ggas') {
        imagePath = 'ggas.png';
    } else if (pOrgCode === 'vsha') {
        imagePath = 'varosha.png';
    } else if (pOrgCode === 'epac') {
        imagePath = 'energypac.png';
    } else if (pOrgCode === 'afm') {
        imagePath = 'afm.png';
    } else if (pOrgCode === 'anh') {
        imagePath = 'anh.png';
    } else if (pOrgCode === 'wfood') {
        imagePath = 'wfood.png';
    } else if (pOrgCode === 'linnex') {
        imagePath = 'linnex.png';
    } else if (pOrgCode === 'united') {
        imagePath = 'united.png';
    } else if (pOrgCode === 'bhai') {
        imagePath = 'bhaibhai.png';
    } else if (pOrgCode === 'panna') {
        imagePath = 'panna.png';
    } else if (pOrgCode === 'mir') {
        imagePath = 'mir.png';
    } else if (pOrgCode === 'crown') {
        imagePath = 'crown.png';
    } else if (pOrgCode === 'rakbd') {
        imagePath = 'rakbd.png';
    } else if (pOrgCode === 'hicon') {
        imagePath = 'hicon.png';
    } else if (pOrgCode === 'dwell') {
        imagePath = 'Drinkwell.png';
    } else if (pOrgCode === 'gtrade') {
        imagePath = 'GoldenTrade.png';
    } else if (pOrgCode === 'dblc') {
        imagePath = 'dblceramics.png';
    } else if (pOrgCode === 'w-food') {
        imagePath = 'well-food.png';
    } else if (pOrgCode === 'umai') {
        imagePath = 'umaifood.png';
    } else if (pOrgCode === 'akijp') {
        imagePath = 'akijplastics.png';
    } else if (pOrgCode === 'tkfood') {
        imagePath = 'tkfood.png';
    } else if (pOrgCode === 'robisfa') {
        imagePath = 'robi.png';
    } else if (pOrgCode === 'need') {
        imagePath = 'needtoiletries.png';
    } else if (pOrgCode === 'bdcom') {
        imagePath = 'bdcom.png';
    } else if (pOrgCode === 'ipdc') {
        imagePath = 'ipdc.png';
    } else if (pOrgCode === 'romania') {
        imagePath = 'romania.png';
    } else if (pOrgCode === 'orient') {
        imagePath = 'orient.png';
    } else if (pOrgCode === 'gazi') {
        imagePath = 'gazi.png';
    } else if (pOrgCode === 'thyrocare') {
        imagePath = 'thyrocare.png';
    }
    else if (pOrgCode === 'pac'){
        imagePath = 'pac.png';
    }
    else if (pOrgCode === 'bpolymer'){
        imagePath = 'bengal-plastics.png';
    }
    else if (pOrgCode === 'akash'){
        imagePath = 'akash.png';
    }
    else if (pOrgCode === 'blpg'){
        imagePath = 'blpg.png';
    }
    else if (pOrgCode === 'rtm'){
        imagePath = 'rtm.png';
    }
    else if (pOrgCode === 'navanawel'){
        imagePath = 'navanawel.png';
    }
    else if (pOrgCode === 'padma'){
        imagePath = 'padma.png';
    }
    else if (pOrgCode === 'orea'){
        imagePath = 'orea.png';
    }
    else if (pOrgCode === 'acme'){
        imagePath = 'acme.png';
    }
    else if (pOrgCode === 'dbandhu'){
        imagePath = 'deshbandhu.png';
    }
    else if (pOrgCode === 'lovello'){
        imagePath = 'lovello.png';
    }
    else if (pOrgCode === 'redmin'){
        imagePath = 'redmin.png';
    }
    else if (pOrgCode === 'biocell'){
        imagePath = 'biocell.png';
    }
    else if (pOrgCode === 'apl'){
        imagePath = 'apl.png';
    } else if (pOrgCode === 'marcopolo') {
        imagePath = 'marcopolo.png';
    }
    return imagePath;
}

export function getOrganizationTheme(pOrgCode: string): FuseConfig {
    let fuseConf = fuseConfig_default;
    if (pOrgCode == null) {
        return fuseConf;
    } else if (pOrgCode === 'epac') {
        fuseConf = fuseConfig_enegrypac_theme;
    }
    else if (pOrgCode === 'pac') {
        fuseConf = fuseConfig_pac_theme;
    }
    else if (pOrgCode === 'epacairflow') {
        fuseConf = fuseConfig_energypac_airflow_theme;
    }
    else if (window.location.href.includes('robimotion') || window.location.href.includes('robisfa')){
        fuseConf = fuseConfig_pac_theme;
    }
    return fuseConf;
}

export function getDatesInBetween(pStartDate: string, pEndDate: string): string[] {
    const dates: string[] = [];
    const currentDate = moment(pStartDate).startOf('day');
    const endDate = moment(pEndDate).startOf('day');

    while (currentDate.diff(endDate) <= 0) {
        dates.push(currentDate.clone().format(SERVER_DATE_FORMAT_WITHOUT_TIME));
        currentDate.add(1, 'days');
    }

    return dates;
}

export function getYearList(pPrevious = 5, pAfter = 0): number[] {
    const years: number[] = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - pPrevious; i <= currentYear + pAfter; i++) {
        years.push(i);
    }
    return years;
}

export const urlConfig = {
    orderListUrl: '/customer-order/list',
    orderAddUrl: '/customer-order/add',
    orderEditUrl: 'edit',
    orderDetailsUrl: ''
};

export function convertToCustomerRef(pCustomer: Customer): CustomerRef {
    const customerRef = new CustomerRef();
    customerRef.id = pCustomer.Id;
    customerRef.name = pCustomer.CustomerName;
    customerRef.code = pCustomer.CustomerCode;
    return customerRef;
}

export function convertToDistributorRef(pDistributor: Distributor): DistributorRef {
    const distributorRef = new DistributorRef();
    distributorRef.id = pDistributor.Id;
    distributorRef.name = pDistributor.Name;
    distributorRef.code = pDistributor.Code;
    return distributorRef;
}

export function convertToMarketRef(pMarket: Market): MarketRef {
    const marketRef = new MarketRef();
    marketRef.id = pMarket.Id;
    marketRef.name = pMarket.Name || pMarket.MarketName;
    marketRef.code = pMarket.Code || pMarket.MarketCode;
    if (pMarket.MarketLevel) {
        marketRef.marketLevel = convertToMarketLevelRef(pMarket.MarketLevel);
    }
    return marketRef;
}

export function convertToMarketLevelRef(pMarketLevel: MarketLevel): MarketLevelRef {
    const marketLevelRef = new MarketLevelRef();
    marketLevelRef.id = pMarketLevel.Id;
    marketLevelRef.name = pMarketLevel.MarketLevelName;
    marketLevelRef.levelRank = pMarketLevel.Rank || pMarketLevel.LevelRank;
    return marketLevelRef;
}

export function convertToProductRef(pProduct: Product): ProductRef {
    const productRef = new ProductRef();
    productRef.id = pProduct.Id;
    productRef.name = pProduct.Name;
    productRef.code = pProduct.Code;
    productRef.retailerPrice = pProduct.RetailerPrice;

    return productRef;
}

export function convertToUserRoleRef(pUserRole: UserRole): UserRoleRef {
    const userRoleRef = new UserRoleRef();
    userRoleRef.id = pUserRole.Id;
    userRoleRef.name = pUserRole.UserRoleName;

    return userRoleRef;
}


